import React from 'react';
import styled from 'styled-components';
import { mediaBreakpointDown, mediaBreakpointUp } from '../../utils/styling';
import Link from '../Link';

const FooterContainer = styled.footer`
	background-color: rgba(240, 245, 248, 0.5);
	padding: 64px 20px 30px;

`;
const FooterContent = styled.div`
	padding: 30px;
	display: flex;
	flex-direction: row;
	position: relative;
	max-width: 1500px;
	margin: 0 auto;
	flex-wrap: wrap;
	justify-content: center;
	align-items: start;
	${mediaBreakpointDown('md')} {
		padding: 0;
	}
	max-width: 1170px;
	margin: auto;
	${mediaBreakpointDown('sm')} {
		flex-direction: column;
	}
`;


const SuperSection = styled.div`
	display: flex;
	margin: 0 0 35px 0;
	padding: 0;
	flex-wrap: wrap;
	flex-direction: column;
	flex-basis: 25%;
	padding: 10px;
	transition: all 0.5s ease-in-out 0s;
	text-wrap: wrap;
	${mediaBreakpointDown('lg')} {
		max-width: 250px;
	}
	${mediaBreakpointDown('md')} {
		max-width: 200px;

	}
	${mediaBreakpointDown('sm')} {
		width: 100%;
		border-bottom: 1px solid #cde;
		margin: 0;
		padding: 0 5px;
		max-width: none;
	}

`

const CategoryList = styled.ul`
	padding-left: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	transition: all 0.5s ease-in-out 0s;
	${mediaBreakpointDown('sm')} {
		transition: all 0.3s ease-in-out 0s;
			display: none;
		}

		${mediaBreakpointUp('md')} {
				display: flex!important;
			}

`;

const CategoryItem = styled.li`
	list-style-type: none;
	font-size: 14px;
	> a {
		text-decoration: none;
		color: #617792;

		&:hover {
			color: #e01efe;
			text-decoration: underline;
		}
	}

	${mediaBreakpointDown('sm')} {
		padding: 5px 10px;
`;

const Terms = styled.div`
	display: block;
	text-align: center;
	font-size: 16px;
	line-height: 2;
	letter-spacing: -0.68px;
	color: #8796a8;
	margin: 25px 0;
	font-weight: 500;
	${mediaBreakpointDown('sm')} {
		margin: 25px auto;
	}
`;

const SectionTitle = styled.div`
	font-weight: 600;
	font-size: 16px;
	display: flex;
	align-items-center;
	${mediaBreakpointDown('md')} {
		min-height: 50px;
	}
	${mediaBreakpointDown('sm')} {
		width: 100%;
		justify-content: space-between;
		display: none;
	}
`

const SectionTitleMobile = styled(SectionTitle)`
	display: none;
	${mediaBreakpointDown('sm')} {
		display: flex;
		min-height: 0;
		padding: 8px 0;
		font-size: 16px;
		opacity: 0.8;
		cursor: pointer;
	}
`

const Expand = styled.span`
	display: none;
	font-size: 14px;

	${mediaBreakpointDown('sm')} {
		display: inline-block;
		padding-left: 10px;
		padding-top: 3px;
	}
`;

const Collapse = styled.span`
	display: none;
	font-size: 14px;

	${mediaBreakpointDown('sm')} {
		display: none;
		padding-left: 10px;
		padding-top: 3px;
	}
`;

const SmallSections = styled.div`
	padding-top: 10px;
	flex-basis: 25%;
	display: flex;
	flex-direction: column;
	${mediaBreakpointDown('md')} {
		max-width: 200px;
		flex-direction: column-reverse;
	}
	${mediaBreakpointDown('sm')} {
		max-width: none;
		width: 100%;
		padding: 0;
		margin: 0;
	}
`;

const MediumSections = styled(SmallSections)``;

const SmallSuperSection = styled(SuperSection)`
	margin: 0;
	padding: 0 10px;
	${mediaBreakpointDown('md')} {
		max-width: 200px;
	}
	${mediaBreakpointDown('sm')} {
		max-width: none;

		padding: 0 5px;
	}
`;

const protectYourMoney = [{
	label: 'Burner Phones',
	linkRelationship: null,
	target: null,
	url: '/burner-phones/',
},
{
	label: 'Airline Flight Compensation Hacks',
	linkRelationship: null,
	target: null,
	url: '/airline-flight-compensation/',
},
{
	label: 'Virtual Credit Cards',
	linkRelationship: null,
	target: null,
	url: '/credit-cards/',
},
{
	label: "Get Free Trials & Don't Get Charged",
	linkRelationship: null,
	target: null,
	url: '/free-trials/',
},
// {
// 	label: 'Insurance Claims',
// 	linkRelationship: null,
// 	target: null,
// 	url: '/insurance-claims/',
// },
{
	label: 'Warranty Claims',
	linkRelationship: null,
	target: null,
	url: '/claim-a-warranty/',
},
]

const customerserviceIssue = [
	{
		label: 'Jump the Phone Queue for Any Company',
		linkRelationship: null,
		target: null,
		url: '/customer-service/',
	},
	{
		label: 'Late Delivery Refunds',
		linkRelationship: null,
		target: null,
		url: '/late-delivery-refunds/',
	},
	{
		label: 'Item Return Request',
		linkRelationship: null,
		target: null,
		url: '/item-return-requests/',
	},
	{
		label: 'Cancel A Subscription',
		linkRelationship: null,
		target: null,
		url: '/how-to-cancel/',
	},
	{
		label: 'Chargebacks and Refunds',
		linkRelationship: null,
		target: null,
		url: '/chargebacks-and-refunds/',
	},
	{
		label: 'Appeal Banned Account',
		linkRelationship: null,
		target: null,
		url: '/appeal-banned-account/',
	},
];

const legalTools = [
	{
		label: 'Appeal Parking Tickets',
		url: '/parking-tickets/',
	},
	{
		label: 'Copyright Protection',
		url: '/copyright-protection/',
	},
	// {
	// 	label: 'Create a Power of Attorney',
	// 	url: '/power-of-attorney/',
	// },
	// {
	// 	label: 'Fight Corporations',
	// 	url: '/small-claims-court/',
	// },
	// {
	// 	label: 'Standardized Legal Documents',
	// 	url: '/standardized-legal-documents/',
	// },
	// {
	// 	label: 'Neighbor Complaints',
	// 	url: '/neighbor-complaints/',
	// },
	// {
	// 	label: 'Stalking and Harassment',
	// 	url: '/stalking-and-harassment/',
	// },
	// {
	// 	label: 'Child Travel Consent Form',
	// 	url: '/child-travel-consent/',
	// },
	// {
	// 	label: 'Fight Workplace Discrimination',
	// 	url: '/fight-workplace-discrimination/',
	// },
	// {
	// 	label: 'HR Complaints',
	// 	url: '/hr-complaints/',
	// },
	// {
	// 	label: 'Defamation Demand Letters',
	// 	url: '/defamation-demand-letters/',
	// },
	{
		label: 'File a Complaint',
		url: '/file-a-complaint/',
	},
	// {
	// 	label: 'Divorce Settlement Agreement',
	// 	url: '/divorce-settlement-agreement/',
	// },
];

const beatBureaucracy = [

	{
		label: 'Connect With an Inmate',
		url: '/connect-with-an-inmate/',
	},
	{
		label: 'Mailing as a Service',
		url: '/mailing-service/',
	},
	{
		label: 'Online Fax',
		url: '/online-fax/',
	},
	{
		label: 'Schedule Appointments With the DMV',
		url: '/dmv-appointments/',
	},
	{
		label: 'Government Tests',
		url: '/government-tests-prep/',
	},
	{
		label: 'Notarize Documents',
		url: '/notarize-any-document/',
	},
	// {
	// 	label: 'Compensation for Victims of Crime',
	// 	url: '/compensation-for-victims-of-crime/',
	// },
	{
		label: 'FOIA',
		url: '/freedom-of-information-act/',
	},
	{
		label: 'Contact Embassies and Consulates',
		url: '/embassies-and-consulates/',
	},
	{
		label: 'Contact Government Representatives',
		url: '/contact-government-representatives/',
	},
	{
		label: 'Create Passport Photos',
		url: '/create-passport-photos/',
	},
	{
		label: 'Notice of Intent To Homeschool',
		url: '/homeschool-letter-of-intent/',
	},
	{
		label: 'Sex Offender Search',
		url: '/sex-offender-search/',
	}

];

const findHiddenMoney = [
	{
		label: 'Gift Card Cash Back',
		url: '/gift-card-cash-back/',
	},
	{
		label: 'Free Raffle Tickets',
		url: '/free-raffle-tickets/',
	},
	{
		label: 'Find Unclaimed Money',
		url: '/missing-money/',
	},
	{
		label: 'Help With Bills',
		url: '/help-with-bills/',
	},
	{
		label: 'College Fee Waivers',
		url: '/college-fee-waiver/',
	},
	{
		label: 'Discover and Apply for Scholarships',
		url: '/discover-and-apply-for-scholarships/',
	},
	{
		label: 'Financial Aid Appeal Letters',
		url: '/financial-aid-appeal-letters/',
	},
]

const fightSpam = [
	{
		label: 'Fight Email Spam',
		url: '/spam-collector/',
	},
	{
		label: 'Fight Text Spam',
		url: '/text-spam/',
	},
	{
		label: 'Robocall Compensation',
		url: '/robocall-compensation/',
	},
];

// const personalFinance = [];

const about = [
	{
		label: 'Terms of Service',
		url: 'https://donotpay.com/learn/terms-of-service/',
	},
	{
		label: 'Privacy Policy',
		url: 'https://donotpay.com/learn/privacy-policy/',
	},
	{
		label: 'Press',
		url: 'https://donotpay.com/about/',
	},
	{
		label: 'Contact',
		url: 'https://donotpay.com/contact',
	},
];

const superSections = [
	// {
	// 	name: "Protect Your Money",
	// 	categories: protectYourMoney
	// },
	// {
	// 	name: "Customer Service Issue",
	// 	categories: customerserviceIssue
	// },
	{
		name: "Protect Your Money",
		categories: legalTools
	},
	{
		name: "Beat Bureaucracy",
		categories: beatBureaucracy
	},
	// {
	// 	name: "Find Hidden Money",
	// 	categories: findHiddenMoney
	// },
	// {
	// 	name: "Fight Spam",
	// 	categories: fightSpam
	// },
	// {
	// 	name: "Personal Finance",
	// 	categories: personalFinance
	// },
	// {
	// 	name: "About",
	// 	categories: about
	// }
];

const smallSections = [
	{
		name: "Protect Your Money",
		categories: protectYourMoney
	},
	{
		name: "Fight Spam",
		categories: fightSpam
	},
	{
		name: "About",
		categories: about
	}
];

const mediumSections = [
	{
		name: "Customer Service Issue",
		categories: customerserviceIssue
	},
	{
		name: "Find Hidden Money",
		categories: findHiddenMoney
	},

];

function onExpand(event) {
	const clearId = event.target.id.replace("_expand", "").replace("_collapse", "");
	const listId = `${clearId}_list`;

	const list = document.getElementById(listId);
	const status = document.getElementById(listId).style.display;

	if (status === "flex") {
		list.style.display = "none";
		document.getElementById(`${clearId}_expand`).innerText = "+";
	} else {
		list.style.display = "flex";
		document.getElementById(`${clearId}_expand`).innerText = "-";
	}
}

const currentYear = new Date().getFullYear();



function NewFooter() {

	return (
		<FooterContainer>
			<FooterContent>

				<SmallSections>
					{smallSections.map((section) => {
						return (
							<SmallSuperSection key={section.name + "1"}>
								<SectionTitle>{section.name} </SectionTitle>
								<SectionTitleMobile id={section.name} onClick={onExpand}>{section.name} <Expand id={`${section.name}_expand`} >+</Expand> <Collapse id={`${section.name}_collapse`}>-</Collapse></SectionTitleMobile>

								<CategoryList id={`${section.name}_list`}>
									{section.categories.map((category) => {
										return (
											<CategoryItem> <Link to={category.url}> {category.label}</Link> </CategoryItem>
										)
									})}
								</CategoryList>
							</SmallSuperSection>
						)
					})}</SmallSections>
				<MediumSections>
					{mediumSections.map((section) => {
						return (
							<SmallSuperSection key={section.name + "1"}>
								<SectionTitle>{section.name} </SectionTitle>
								<SectionTitleMobile id={section.name} onClick={onExpand}>{section.name} <Expand id={`${section.name}_expand`} >+</Expand> <Collapse id={`${section.name}_collapse`}>-</Collapse></SectionTitleMobile>

								<CategoryList id={`${section.name}_list`}>
									{section.categories.map((category) => {
										return (
											<CategoryItem> <Link to={category.url}> {category.label}</Link> </CategoryItem>
										)
									})}
								</CategoryList>
							</SmallSuperSection>
						)
					})}
				</MediumSections>
				{superSections.map((section) => {
					return (
						<SuperSection key={section.name + "1"}>
							<SectionTitle>{section.name} </SectionTitle>
							<SectionTitleMobile id={section.name} onClick={onExpand}>{section.name} <Expand id={`${section.name}_expand`} >+</Expand> <Collapse id={`${section.name}_collapse`}>-</Collapse></SectionTitleMobile>

							<CategoryList id={`${section.name}_list`}>
								{section.categories.map((category) => {
									return (
										<CategoryItem> <Link to={category.url}> {category.label}</Link> </CategoryItem>
									)
								})}
							</CategoryList>
						</SuperSection>
					)
				})}
			</FooterContent>
			<Terms>© {`${currentYear}`} DoNotPay All rights reserved.</Terms>

		</FooterContainer>
	);
}

export default React.memo(NewFooter);
